import { render, staticRenderFns } from "./IndexTenantTwo.vue?vue&type=template&id=7be7ecda&"
import script from "./IndexTenantTwo.vue?vue&type=script&lang=js&"
export * from "./IndexTenantTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports